module.exports = __webpack_public_path__ + "img/DCT.d286fe45.svg";